import React, { useState } from "react";
import { useEffect } from "react";
import styles from './style.module.css';
import { IoIosClose } from "react-icons/io";
import { exportPainMetrics } from "../../services/kollectaHealthCore";

const PainReportFilterTool = ({ closeModal, setFeedback }) => {
  const statusSettings = {
    mild: {
      label: "Pacientes que apresentaram dor leve",
    },
    moderate: {
      label: "Pacientes que apresentaram dor moderada",
    },
    severe: {
      label: "Pacientes que apresentaram dor grave",
    },
    noPain: {
      label: "Pacientes que não apresentaram dor",
    },
    all: {
      label: "Todos os pacientes com dor",
    },
  }

  const [selectedStatuses, setSelectedStatuses] = useState(
    Object.keys(statusSettings).reduce((acc, key) => ({ ...acc, [key]: false }), {})
  );
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleStatusChange = (statusKey) => {
    setSelectedStatuses(prevSelectedStatuses => ({
      ...prevSelectedStatuses,
      [statusKey]: !prevSelectedStatuses[statusKey]
    }));
  };

  const handleExport = async () => {
    setFeedback('isLoading');
  
    let selectedStatusKeys = Object.keys(selectedStatuses).filter(key => selectedStatuses[key]);
  
    // Construir parâmetros de data
    const dateParams = new URLSearchParams();
    if (startDate) dateParams.append('startDate', startDate);
    if (endDate) dateParams.append('endDate', endDate);
  
    // Se 'all' está selecionado, exporta todos os pacientes com dor
    if (selectedStatusKeys.includes('all')) {
      try {
        const blob = await exportPainMetrics('all', dateParams.toString());
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = 'metricas-dor-todos.xlsx';
        document.body.appendChild(a);
        a.click();
    
        URL.revokeObjectURL(downloadUrl);
        a.remove();
        setFeedback('isSuccess');
      } catch (error) {
        setFeedback('isError');
        console.error("Erro ao exportar o relatório:", error);
      }
      return;
    }
  
    // Se nenhum filtro foi selecionado, exporta todos os pacientes com dor
    if (selectedStatusKeys.length === 0) {
      try {
        const blob = await exportPainMetrics('all', dateParams.toString());
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = 'metricas-dor-todos.xlsx';
        document.body.appendChild(a);
        a.click();
    
        URL.revokeObjectURL(downloadUrl);
        a.remove();
        setFeedback('isSuccess');
      } catch (error) {
        setFeedback('isError');
        console.error("Erro ao exportar o relatório:", error);
      }
      return;
    }
  
    // Exporta cada tipo de filtro selecionado
    try {
      for (const filterType of selectedStatusKeys) {
        const blob = await exportPainMetrics(filterType, dateParams.toString());
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `metricas-dor-${filterType}.xlsx`;
        document.body.appendChild(a);
        a.click();
    
        URL.revokeObjectURL(downloadUrl);
        a.remove();
      }
      setFeedback('isSuccess');
    } catch (error) {
      setFeedback('isError');
      console.error("Erro ao exportar o relatório:", error);
    }
  };  

  useEffect(() => {
  }, [selectedStatuses]);


  return (
    <section className={styles.wrapper}>
      <div className={styles.top}>
       <h2>Escolha as informações do seu relatório</h2>
       <button onClick={() => closeModal(false)} className={styles.close}><IoIosClose /></button>
      </div>
      
      <div className={styles.container}>
          <div className={styles.subContainer}>
            <div className={styles.radiosContainer}>
              {Object.entries(statusSettings).map(([key, { label }]) => (
              <div key={key} className={styles.radioItem}>
                <input 
                  type="checkbox" 
                  id={key} 
                  name="status"
                  className={styles.customCheckbox}
                  checked={selectedStatuses[key]}
                  onChange={() => handleStatusChange(key)}
                />
                <div className={styles.radioTexts}>
                  <label htmlFor={key}>{label}</label>
                </div>
              </div>
             ))}
            </div>
          </div>
          
          <div className={styles.dateContainer}>
            <div className={styles.dateInputs}>
              <div className={styles.dateInput}>
                <label htmlFor="startDate">Data de início:</label>
                <input
                  type="date"
                  id="startDate"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className={styles.dateInput}>
                <label htmlFor="endDate">Data de fim:</label>
                <input
                  type="date"
                  id="endDate"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
          </div>
      </div>
      <button onClick={handleExport} className={styles.generalButton}>Exportar Relatório</button>

    </section>
  );
};

export default PainReportFilterTool; 